import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Wrapper,
  Row,
  Button,
  Icon,
  Copy,
  Bold,
  Title,
  Spin
} from "app/NativeComponents/common";
import OwnerImage from "./OwnerImage";
import ContactInformation from "./ContactInformation";

import {
  getOwnerInfo,
  setEditModal,
  updateOwnerInfo,
  determineMainOwnerInfo,
  skipTrace,
  formatAddress
} from "app/NativeActions";

class OwnerInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      owner_info: determineMainOwnerInfo(props.active_property),
      temp_owner_name: null
    };
  }

  componentDidMount() {
    if (
      this.props.active_property.deal &&
      this.props.active_property.deal.removed != 1
    ) {
      this.props.getOwnerInfo({
        token: this.props.token,
        deal_id: this.props.active_property.deal.id
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      active_property,
      main_owner_info,
      token,
      getOwnerInfo
    } = this.props;
    if (active_property && prevProps.active_property) {
      if (
        active_property.property_id !== prevProps.active_property.property_id
      ) {
        this.setState({ owner_info: determineMainOwnerInfo(active_property) });

        if (active_property.deal) {
          getOwnerInfo({ token, deal_id: active_property.deal.id });
        }
      }

      if (active_property.deal && !prevProps.active_property.deal) {
        getOwnerInfo({ token: token, deal_id: active_property.deal.id });
      }

      if (active_property.deal && !prevProps.active_property.deal) {
        getOwnerInfo({ token: token, deal_id: active_property.deal.id });
      }

      if (
        active_property.deal &&
        prevProps.active_property.deal &&
        active_property.deal.id == prevProps.active_property.deal.id &&
        active_property.deal.did_skip_trace !=
          prevProps.active_property.deal.did_skip_trace
      ) {
        this.setState({ owner_info: determineMainOwnerInfo(active_property) });
        getOwnerInfo({ token, deal_id: active_property.deal.id });
      }
    } else if (active_property && !prevProps.active_property) {
      this.setState({ owner_info: determineMainOwnerInfo(active_property) });
      if (active_property.deal) {
        getOwnerInfo({ token: token, deal_id: active_property.deal.id });
      }
    }

    if (main_owner_info && main_owner_info !== prevProps.main_owner_info) {
      this.setState({ owner_info: main_owner_info });
    }
  }

  setTempOwnerName(owner_name = null) {
    this.setState({ temp_owner_name: owner_name });
  }

  renderEditOwnerButton() {
    if (
      this.props.active_property.deal &&
      this.props.active_property.deal.removed != 1
    ) {
      if (
        !this.state.owner_info.owner_name ||
        this.state.owner_info.owner_name === ""
      ) {
        return (
          <Button
            onPress={() => {
              this.props.setEditModal({
                title: "Add Owner",
                description:
                  "Add owner to " + this.props.active_property.property_address,
                slug: "add-owner",
                type: "add_owner",
                fields: {
                  owner_name: "",
                  address: "",
                  address2: "",
                  city: "",
                  state: "",
                  zip: ""
                },
                save_button_text: "Add Owner",
                modalAction: ({ fields }) => {
                  this.props.updateOwnerInfo({
                    token: this.props.token,
                    deal_id: this.props.active_property.deal.id,
                    type: "owner_name_and_address",
                    owner_name: fields.owner_name,
                    address: fields.address,
                    address2: fields.address2,
                    city: fields.city,
                    state: fields.state,
                    zip: fields.zip,
                    send_to_address: 1
                  });
                }
              });
              this.props.appRedirect({
                redirect: "goForward",
                payload: { add: "add-owner" }
              });
            }}
          >
            <Row>
              <Icon
                color={this.props.colors.active_color}
                icon={"add"}
                size={14}
              />
              <Copy
                style={{ color: this.props.colors.active_color, fontSize: 10 }}
              >
                Add Owner
              </Copy>
            </Row>
          </Button>
        );
      } else {
        return (
          <Row>
            <Button
              onPress={() => {
                this.props.setEditModal({
                  title: "Edit Owner",
                  description:
                    "Edit owner for " +
                    this.props.active_property.property_address,
                  slug: "edit-owner",
                  type: "edit_owner",
                  fields: {
                    owner_name: this.state.owner_info.owner_name,
                    address: this.state.owner_info.owner_address,
                    address2: this.state.owner_info.owner_address2,
                    city: this.state.owner_info.owner_address_city,
                    state: this.state.owner_info.owner_address_state,
                    zip: this.state.owner_info.owner_address_zip,
                    send_to_address: this.state.owner_info.send_to_owner_address
                  },
                  save_button_text: "Save Owner",
                  modalAction: ({ fields }) => {
                    this.props.updateOwnerInfo({
                      token: this.props.token,
                      deal_id: this.props.active_property.deal.id,
                      type: "edit_owner_name_and_address",
                      owner_name: fields.owner_name,
                      address: fields.address,
                      address2: fields.address2,
                      city: fields.city,
                      state: fields.state,
                      zip: fields.zip,
                      send_to_address: fields.send_to_address
                    });
                  }
                });
                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "edit-owner" }
                });
              }}
              style={{ marginRight: 10 }}
            >
              <Row>
                <Icon
                  color={this.props.colors.active_color}
                  icon={"edit"}
                  size={14}
                />
                <Copy
                  style={{
                    color: this.props.colors.active_color,
                    fontSize: 10
                  }}
                >
                  Edit Owner
                </Copy>
              </Row>
            </Button>
            {this.renderRestoreOwnerButton()}
          </Row>
        );
      }
    }
  }

  renderRestoreOwnerButton() {
    if (
      this.props.active_property.owner_name &&
      this.props.active_property.owner_name !== "" &&
      this.state.owner_info.custom_owner === true &&
      this.props.active_property.property_data_type != "phantom"
    ) {
      return (
        <Button
          onPress={() => {
            this.props.updateOwnerInfo({
              token: this.props.token,
              deal_id: this.props.active_property.deal.id,
              type: "sync_owner_name_and_address",
              owner_name: this.props.active_property.owner_name,
              address: this.props.active_property.owner_address,
              address2: this.props.active_property.owner_address2,
              city: this.props.active_property.owner_address_city,
              state: this.props.active_property.owner_address_state,
              zip: this.props.active_property.owner_address_zip,
              send_to_address: this.state.owner_info.send_to_owner_address
            });
          }}
          style={{ marginRight: 10 }}
        >
          <Row>
            <Icon
              color={this.props.colors.active_color}
              icon={"refresh"}
              size={14}
            />
            <Copy
              style={{ color: this.props.colors.active_color, fontSize: 10 }}
            >
              Sync With County Records
            </Copy>
          </Row>
        </Button>
      );
    }
  }

  renderBusinessOwnerName() {
    if (
      this.state.owner_info.did_skip_trace === 1 &&
      this.state.owner_info.skip_trace_successful === 1 &&
      this.state.owner_info.owner_status_info.slug === "corporate_owner"
    ) {
      if (
        this.state.owner_info.skip_trace_owner_name &&
        this.state.owner_info.skip_trace_owner_name != ""
      ) {
        return (
          <Copy>
            Business Owner: {this.state.owner_info.skip_trace_owner_name}
          </Copy>
        );
      }
    }
  }

  renderMailingAddress() {
    const { active_property } = this.props;
    if (
      !active_property.deal ||
      active_property.deal == null ||
      (active_property.deal && active_property.deal.removed == 1)
    ) {
      const formatted_address = formatAddress({
        address: {
          address: active_property.owner_address,
          address2: active_property.owner_address_2,
          address_city: active_property.owner_address_city,
          address_state: active_property.owner_address_state,
          address_zip: active_property.owner_address_zip
        }
      });
      return (
        <Wrapper>
          <Copy>{formatted_address.line1}</Copy>
          <Copy>{formatted_address.line2}</Copy>
        </Wrapper>
      );
    }
  }

  renderOwnerTitle() {
    if (
      this.state.owner_info.owner_name &&
      this.state.owner_info.owner_name !== ""
    ) {
      return (
        <Wrapper>
          <Title>
            {this.state.temp_owner_name && this.state.temp_owner_name !== ""
              ? this.state.temp_owner_name
              : this.state.owner_info.owner_name}
          </Title>
          {this.renderBusinessOwnerName()}
          {this.renderMailingAddress()}
        </Wrapper>
      );
    }
  }

  render() {
    if (
      this.state.owner_info &&
      //!this.props.owner_loading &&
      this.props.user.team_clearance_level > 0
    ) {
      return (
        <Wrapper>
          <Card>
            <CardBody>
              <Row>
                <OwnerImage
                  colors={this.props.colors}
                  owner_name={
                    this.state.temp_owner_name &&
                    this.state.temp_owner_name !== ""
                      ? this.state.temp_owner_name
                      : this.state.owner_info.owner_name
                  }
                  owner_firstname={this.state.owner_info.owner_firstname}
                  owner_lastname={this.state.owner_info.owner_lastname}
                  owner_status_info={this.state.owner_info.owner_status_info}
                  owner_image={""}
                />
                <Wrapper>
                  <Row>
                    <Copy>
                      <Bold>
                        {this.state.owner_info.owner_name &&
                        this.state.owner_info.owner_name !== ""
                          ? this.state.owner_info.owner_status_info
                            ? this.state.owner_info.owner_status_info.text
                            : "Owner Not Found"
                          : "Owner Not Found"}
                      </Bold>
                    </Copy>
                  </Row>
                  {this.renderOwnerTitle()}
                  <Row>{this.renderEditOwnerButton()}</Row>
                </Wrapper>
              </Row>
            </CardBody>
            <ContactInformation
              owner_info={this.state.owner_info}
              {...this.props}
            />
          </Card>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ owner, native }) => {
  const { main_owner_info, owner_loading } = owner;
  const { device, isMobile } = native;
  return {
    main_owner_info,
    owner_loading,
    device,
    isMobile
  };
};

export default connect(mapStateToProps, {
  getOwnerInfo,
  updateOwnerInfo,
  setEditModal
})(OwnerInfo);
